export const proAccountApiUrl = '/pro-account';
export const proInstallationApiUrl = '/pro-installation';

export const USEFUL_LINKS = [
  {
    label: 'dashboard.usefulLinks.proSizer',
    url: 'https://prosizer.mylight-systems.com/',
  },
  {
    label: 'dashboard.usefulLinks.training',
    url: 'https://www.mylight150.com/espace-pro/formations',
  },
  {
    label: 'dashboard.usefulLinks.helpDesk',
    url: 'https://intercom-help.eu/mylight150com/fr/collections/1193408-centre-d-aide-installateur',
  },
  {
    label: 'dashboard.usefulLinks.suggestEnhancement',
    url: 'https://mylight150.typeform.com/to/W4vIJMu2?typeform-source=statics.teams.cdn.office.net',
  },
];

export const MYLIGHT_FAILURES_RATE = 10;
export const MYLIGHT_MEDIAN_TIME_TO_ACTIVATION_IN_DAYS = 30;
export const MYLIGHT_AVERAGE_INSTALLED_EQUIPMENTS_COUNT = 0.75;

export const INSTALLATION_GUIDE_URL = 'https://ml150.pro/guide/';
